import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import MoreOptionsIcon from 'dibs-vg/dist/react/more-options';

import styles from './SbRespCustomizable.scss';

export function SbRespCustomizable({ pdpURL }) {
    return (
        <div className={styles.container}>
            <a href={pdpURL} className={styles.link}>
                <MoreOptionsIcon className={styles.icon} />
                <FormattedMessage
                    id="sb.SbRespCustomizable.customizableLabel"
                    defaultMessage="More Options"
                />
            </a>
        </div>
    );
}

SbRespCustomizable.propTypes = {
    pdpURL: PropTypes.string.isRequired,
};
